import { routes as Home } from '@/views/home/index.js'
import { routes as Users } from '@/views/users/index.js'

import { routes as SendedCi } from '@/views/ci/sended/index.js'
import { routes as ReceivedCi } from '@/views/ci/received/index.js'
import { routes as AllCi } from '@/views/ci/all/index.js'

import { routes as DepartmentsAdmin } from '@/views/admin/departments/index.js'
import { routes as WorkstationsAdmin } from '@/views/admin/workstations/index.js'
import { routes as RoleAdmin } from '@/views/admin/role/index.js'
import { routes as FunctionsAdmin } from '@/views/admin/functions/index.js'
import { routes as ScalesAdmin } from '@/views/admin/scales/index.js'
import { routes as IncomeTax } from '@/views/users/incomeTax/index.js'

export default [
  {
    path: '/',
    name: 'dashboard',
    redirect: '/home',
    component: () => import('./Dashboard.vue'),
    meta: {
      name: 'Dashboard',
      auth: true,
      user: 'Admin',
    },
    children: [
      ...Home,
      ...Users,
      ...SendedCi,
      ...ReceivedCi,
      ...AllCi,
      ...IncomeTax,
      ...DepartmentsAdmin,
      ...WorkstationsAdmin,
      ...FunctionsAdmin,
      ...RoleAdmin,
      ...ScalesAdmin,
    ],
  },
]
